// Self-selected study context, never an age category or evidence of enrolment.
export const currentStudyTypes = Object.freeze({
  secondary: 'High school / secondary school',
  further: 'College / further education',
  foundation: 'Access / foundation course',
  undergraduate: 'Undergraduate degree',
  postgraduate: 'Postgraduate study',
  vocational: 'Vocational study / apprenticeship',
  professional: 'Professional development',
  independent: 'Independent study',
  other: 'Other study',
});
